module.exports = __webpack_public_path__ + "img/1.406474eb.jpg";